export const msTeams = 'msteams';
export const browser = 'browser';

export const defaultClient = () => ({
  clientType: browser,
  msTeamsContext: null,
});
